import store from '../../store'

export function setDoNotDisturbUntil(doNotDisturbUntil){
    const state = store.getState()
    store.dispatch({type:'SET_DO_NOT_DISTURB_UNTIL',doNotDisturbUntil:doNotDisturbUntil})
}
